export const DialogChoiceName = 'DialogChoice';
